// extracted by mini-css-extract-plugin
export default {"withHover":"Icon_withHover__9mU4d"};